import Cookies from 'js-cookie';
import { dispatchCustomEvent } from './utilities/custom-events';
import { replacementTokens, getReplacementPatterns } from './replacements';

const DISABLED_CLASS = 'dr-cta-disabled';
const FALLBACK_TIMEOUT_MS = 3000;

let disabledElements = [];

function getCardType() {
    const rawType = Cookies.get('disneyrewards-cardmember-type') || 'classic';
    return ['classic', 'premier', 'inspire'].includes(rawType) ? rawType : 'classic';
}

function hasTokens(href) {
    return /\(\(.*?\)\)|\{.*?\}/.test(href);
}

function disableCtas() {
    const links = document.querySelectorAll('a[href]');
    disabledElements = [];

    links.forEach((link) => {
        if (hasTokens(link.getAttribute('href'))) {
            link.classList.add(DISABLED_CLASS);
            disabledElements.push(link);
        }
    });
}

function enableCtas() {
    disabledElements.forEach((link) => {
        link.classList.remove(DISABLED_CLASS);
    });
    disabledElements = [];
}

function applyDefaults() {
    const defaults = window.drTrackingDefaults;
    if (!defaults) {
        return;
    }

    const cardType = getCardType();

    function getDefaultValue(token) {
        switch (token) {
            case 'cell': {
                return defaults.cell[cardType]
                    || defaults.cellOrganic
                    || defaults.cell.classic
                    || '';
            }
            case 'cat':
            case 'cat_classic':
            case 'cat_premier':
            case 'cat_inspire':
                return '';
            case 'lgc':
            case 'lgc_classic':
                return defaults.lgc.classic || '';
            case 'lgc_premier':
                return defaults.lgc.premier || '';
            case 'lgc_inspire':
                return defaults.lgc.inspire || '';
            case 'spid':
            case 'spid_classic':
                return defaults.spid.classic || '';
            case 'spid_premier':
                return defaults.spid.premier || '';
            case 'spid_inspire':
                return defaults.spid.inspire || '';
            default:
                return '';
        }
    }

    disabledElements.forEach((link) => {
        let href = decodeURI(link.getAttribute('href'));

        Object.values(replacementTokens).forEach((token) => {
            const patterns = getReplacementPatterns(token);
            const value = getDefaultValue(token);
            patterns.forEach((pattern) => {
                href = href.replace(pattern, value);
            });
        });

        link.setAttribute('href', href);
    });
}

function startTimeout() {
    const timer = setTimeout(() => {
        applyDefaults();
        enableCtas();
        dispatchCustomEvent('trackingCodesReady');
    }, FALLBACK_TIMEOUT_MS);

    return timer;
}

export function initCtaGuard() {
    disableCtas();

    const timeout = startTimeout();

    window.addEventListener('trackingCodesReady', () => {
        clearTimeout(timeout);
        enableCtas();
    }, { once: true });
}
